module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errPage-container"
  }, [_c('el-button', {
    staticClass: "pan-back-btn",
    attrs: {
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h1', {
    staticClass: "text-jumbo text-ginormous"
  }, [_vm._v("Oops!")]), _vm._v("\n       gif来源"), _c('a', {
    attrs: {
      "href": "https://zh.airbnb.com/",
      "target": "_blank"
    }
  }, [_vm._v("airbnb")]), _vm._v(" 页面\n      "), _c('h2', [_vm._v("你没有权限去该页面")]), _vm._v(" "), _c('h6', [_vm._v("如有不满请联系你领导")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("或者你可以去:")]), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("回首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('a', {
    attrs: {
      "href": "https://www.taobao.com/"
    }
  }, [_vm._v("随便看看")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("点我看图")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.errGif,
      "width": "313",
      "height": "428",
      "alt": "Girl has dropped her ice cream."
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "随便看",
      "visible": _vm.dialogVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticClass: "pan-img",
    attrs: {
      "src": _vm.ewizardClap
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa10904","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/error/401.vue
// module id = 923
// module chunks = 1